import { ReactElement, useEffect, useState } from 'react';
import StandaloneMap from './StandaloneMap';
import { useNavigate } from 'react-router-dom';
import { isSidecarEvent, SidecarMessage } from '@/lib/sidecar';

const NoAlertSelected = () => {
  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center gap-4 text-white">
      <h1 className="font-sans text-5xl font-black">No alert selected</h1>
      <p className="text-2xl">Select an Alert to bring up the map in Sidecar.</p>
    </div>
  );
};

const NotConnected = () => {
  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center gap-5">
      <h1 className="font-sans text-5xl font-black text-white">Sidecar is disconnected</h1>
      <h2 className="font-sans text-3xl font-black text-white">
        Connect sidecar by launching through watchful
      </h2>
    </div>
  );
};

const Sidecar = () => {
  const [element, setElement] = useState<ReactElement>(<NotConnected />);
  const navigate = useNavigate();

  useEffect(() => {
    const handelMessage = (event: MessageEvent) => {
      const { data } = event;

      if (!event.origin.startsWith(window.location.origin)) {
        console.log('Invalid origin ' + event.origin);
        return;
      }

      if (!isSidecarEvent(data)) {
        return;
      }

      switch (data.sidecarMessage) {
        case 'openMap': {
          setElement(<StandaloneMap {...data} />);
          break;
        }
        case 'noAlert': {
          setElement(<NoAlertSelected />);
        }
      }
    };

    window.addEventListener('message', handelMessage);

    if (window.opener) {
      window.opener.postMessage(
        { sidecarMessage: 'loaded' } as SidecarMessage,
        window.location.href
      );
    } else {
      navigate('/');
    }

    return () => window.removeEventListener('message', handelMessage);
  }, []);

  return element;
};

export default Sidecar;
